/// <reference types="jasmine" />

import { of } from 'rxjs';

import { TranslationService, TranslationParams } from '../services/translation.service';

export function createTranslationServiceMock(): jasmine.SpyObj<TranslationService> {
  const mockService = jasmine.createSpyObj('TranslationService', [
    'translate',
    'setTitle',
    'getActiveLang',
    'getAvailableLangs',
    'getTranslation',
    'createTranslatedFieldOptions',
    'setActiveLang',
    'initialize',
    'translationReady$',
    'translateWeekday',
    'createTranslatedPaginatorIntl',
    'translateTimeAgo',
  ], {
    events$: of({ type: 'translationLoadSuccess' as const, wasFailure: false, payload: {} }),
  });

  mockService.translate.and.callFake((key: string, params?: TranslationParams) => {
    if (params && typeof key === 'string') {
      return Object.entries(params).reduce(
        (str, [paramKey, value]) => str.replace(new RegExp(`\\{\\{${paramKey}\\}\\}`, 'g'), String(value)),
        key
      );
    }
    return key;
  });

  mockService.setTitle.and.callFake((title: string) => of(title));

  mockService.getActiveLang.and.returnValue('en-US');

  mockService.getAvailableLangs.and.returnValue(['en-US', 'en-XA']);

  mockService.getTranslation.and.returnValue({});

  mockService.createTranslatedFieldOptions.and.callFake((labelKey: string, placeholderKey?: string) => ({
    label: labelKey,
    placeholder: placeholderKey,
  }));

  mockService.setActiveLang.and.stub();

  mockService.initialize.and.stub();

  mockService.translationReady$.and.returnValue(of(true));

  mockService.translateWeekday.and.callFake((weekday: string) => weekday);

  mockService.createTranslatedPaginatorIntl.and.returnValue({
    itemsPerPageLabel: 'common.itemsPerPage',
    nextPageLabel: 'common.nextPage',
    previousPageLabel: 'common.previousPage',
    firstPageLabel: 'common.firstPage',
    lastPageLabel: 'common.lastPage',
    getRangeLabel: (page: number, pageSize: number, length: number) => 
      `common.rangePageLabel`,
    changes: of(),
  } as any);

  mockService.translateTimeAgo.and.callFake((date: Date | number) => 'common.timeAgo.justNow');

  return mockService;
}


